import { api, type ApiError } from "@/api/client";
import type { Session } from "@/session/types";

export type AuthResponse = Session & {
  wallets?: unknown[];
  note?: string;
};

export async function register(
  username: string,
  password: string
): Promise<AuthResponse> {
  return api<AuthResponse>("/auth/register", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

export async function login(username: string, password: string): Promise<AuthResponse> {
  return api<AuthResponse>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

export async function authMe(token: string): Promise<AuthResponse> {
  return api<AuthResponse>("/auth/me", {}, token);
}

export function errorMessage(e: unknown): string {
  if (e && typeof e === "object" && "message" in e) {
    const m = String((e as ApiError).message || "");
    const code = String((e as ApiError).code || "");
    const raw = `${code} ${m}`.toUpperCase();
    if (/401|UNAUTHORIZED|SESSION|EXPIRED/.test(raw)) return "سشن";
    if (/USERNAME_OR_PASSWORD|PASSWORD_MISMATCH|INVALID/.test(raw)) return "نامعتبر";
    if (/HTTP_?40[034]/.test(raw) || /^HTTP_/.test(m)) return "خطا";
    if (/NETWORK|FETCH|FAILED TO FETCH/.test(raw)) return "شبکه";
    if (m && !/^HTTP_/.test(m) && m.length < 80) return m;
  }
  return "خطا";
}
